import swal from 'sweetalert2';
const GlobalStore = {
    isLoadRouterView: false,
    settingMenuShow: false,
    settingMenuShow_create: false,
    settingMenuShow_update: false,
    settingMenuShow_delete: false,

    menuAdsDesign: false,
    menuAdsDesign_create: false,
    menuAdsDesign_update: false,
    menuAdsDesign_delete: false,

    menuCampaign: false,
    menuCampaign_create: false,
    menuCampaign_update: false,
    menuCampaign_delete: false,

    menuLeadsPeek: false,
    menuLeadsPeek_create: false,
    menuLeadsPeek_update: false,
    menuLeadsPeek_delete: false,
    menuLeadsPeek_type: '',
    menuLeadsPeek_typeLocator:'',

    menuDashboard: false,

    menuUserType: '',
    userTypeOri: '',
    systemUser: false,
    idsys:'',
    masteridsys: '',
    rootcomp: false,
    agencyplatformroot:false,
    companyrootname:'',
    companyrootlegalname:'',
    companyrootphone:'',
    companyrootnameshort:'',
    companyrootaddres:'',
    companyrootcity:'',
    companyrootzip:'',
    companyrootstatecode:'',
    companyrootstatename:'',
    companyrootdomain:'',
    companyrootsubdomain:'',

    systemTimezone: 'America/Chicago',
    clientTimezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
    
    userrootname:'',
    userrootemail:'',
    userrootaddres:'',
    userrootcity:'',
    userrootzip:'',
    userrootstatecode:'',
    userrootstatename:'',
    sppubkey: '',
    recapkey: '',
    isRadioLockedProfile: false,
    
    charges_enabled: false,
    payouts_enabled: false,
    account_requirements: '',

    rootpaymentterm: '',

    creditcardsetup: false,
    creditCardSetupStatus : '',
    stripeaccountconnectedStatus : '',
    stripescriptload: false,
    questionnairesetup: false,
    stripeaccountconnected:false,
    statusaccountconnected: '',

    disabledaddcampaign: false,
    apiMode: false,
    hasVisibleIntegrations: true, // Default: show all integrations

    selectsGroupCompany: {
        companyGroupList : [],
    },

    QuestionnaireCurrsection : 1,
    QuestionnairePrevsection : 1,
    Questionnaire_local_LeadspeekMinCostMonth: 0,
    Questionnaire_local_LeadspeekCostperlead: 0,

    paymentStatusFailed: false,
    clientPaymentFailed: false,
    agencyPaymentFailed: false,
    failedCampaignNumber: [],
    failedInvoiceAmount:[],
    failedPrepaidCampaignIds: [],
    
    /** FOR PHOTO AND COMPANY TITLE */
    globalCompanyName: 'Company Name',
    globalCompanyPhoto: '',
    globalProfilePhoto: '',
    globalBoxBgColor: 'ffffff',
    globalTextColor: '',
    globalLinkColor: '',
    
    globalTemplateBgColor: '',
    globalSidebarBgColor: '',
    globalFontTheme: '',

    globalviewmode:false,
    globalviewmodeclient: false,

    globalClient: {
      name: '',
      address: '',
      city: '',
      zip: '',
      fulladdress: '',
      statename: '',
      companyname: '',
      companyemail: '',
      companyfulladdress:'',
    },

    globalModulNameLink: {
        local: { 
          name: 'Site ID',
          url: 'siteid',
        },
        locator: {
          name: 'Search ID',
          url: 'searchid',
        },
        enhance: {
          name: 'Enhance ID',
          url: 'enhanceid',
        },
        b2b: {
          name: 'B2B ID',
          url: 'b2bid',
        },
        simplifi: {
          name: 'Simplifi ID',
          url: 'simplifiid',
        },
    },

    isBeta: false,
    betaFeature: {
      data_wallet: {
        id: 1,
        slug: 'data_wallet',
        name: 'Data Wallet',
        is_beta: false,
        apply_to_all_agency: false
      },
      b2b_module: {
        id: 2,
        slug: 'b2b_module',
        name: 'B2B Module',
        is_beta: false,
        apply_to_all_agency: false
      },
      simplifi_module: {
        id: 3,
        slug: 'simplifi_module',
        name: 'Simplifi Module',
        is_beta: false,
        apply_to_all_agency: false
      }
    },
    rootminspendsetting: {
      status:false,
      first_month:0,
      second_month:0,
      monthly:0
    },
    agency_onboarding_status: false,
    agency_onboarding_price: 0,
    isLoadingContent: false,
    agency_enable_coupon: false,
    otp_token: '',
    manual_bill : null,
    searchQueryAgencyList: '',
    createAnAccountStatus : false ,
    isIntegrationClicked : false,
    integrationSnapshot: null, // Snapshot of original integration data
    isLoadingIntegrationData: false, // Flag to prevent watchers during data load
    isBlankCharacterRegexp : /[\u3164\u2800\u115F\u1160\uFFA0\u200B-\u200D\uFEFF]/,
    modals: {
      billingAgreementDirectPayment: false,
      serviceAgreement: false,
    },
    
  initAllMenu() {
    this.settingMenuShow = false;
    this.settingMenuShow_create = false,
    this.settingMenuShow_update = false,
    this.settingMenuShow_delete = false,

    this.menuAdsDesign = false;
    this.menuAdsDesign_create = false;
    this.menuAdsDesign_update = false;
    this.menuAdsDesign_delete = false;

    this.menuCampaign = false;
    this.menuCampaign_create = false;
    this.menuCampaign_update = false;
    this.menuCampaign_delete = false;

    this.menuLeadsPeek = false;
    this.menuLeadsPeek_create = false;
    this.menuLeadsPeek_update = false;
    this.menuLeadsPeek_delete = false;
    this.menuLeadsPeek_type = '',
    this.menuLeadsPeek_typeLocator = '',

    this.menuDashboard = false;

  },
  checkClientModule(setupComplete,accessmodule) {
    this.initAllMenu();
    
    if (setupComplete == 'F') {
      return;
    }
    //console.log(accessmodule);
    this.menuAdsDesign = false;
    this.menuCampaign = false;
    this.settingMenuShow = false;
    this.menuLeadsPeek = false;
    this.menuLeadsPeek_update = false;
    
    if (accessmodule['leadspeek']) {
      this.menuLeadsPeek = true;
      this.menuLeadsPeek_update = true;
      this.menuLeadsPeek_delete = true;
    }
    
    var lptype = accessmodule['leadspeek_type'];
    lptype = lptype.split('|');
    for(var i=0;i<lptype.length;i++) {
      if (lptype[i] == 'local') {
        this.menuLeadsPeek_type = lptype[i];
      }else{
        this.menuLeadsPeek_typeLocator = lptype[i];
      }
    }
    
  },
  checkModuleRole(roleModuleUser,setupComplete) {
    //console.log(roleModuleUser);
    this.initAllMenu();

    if (setupComplete == 'F') {
      return;
    }
    
    for(var i=0;i<roleModuleUser.length;i++) {
      if (roleModuleUser[i]['module_name'] == 'Ads Design') {
          this.menuAdsDesign = roleModuleUser[i]['enable_permission'];
          this.menuAdsDesign_create = roleModuleUser[i]['create_permission'];
          this.menuAdsDesign_update = roleModuleUser[i]['update_permission'];
          this.menuAdsDesign_delete = roleModuleUser[i]['delete_permission'];

        }else if (roleModuleUser[i]['module_name'] == 'Campaign') {
          this.menuCampaign = roleModuleUser[i]['enable_permission'];
          this.menuCampaign_create = roleModuleUser[i]['create_permission'];
          this.menuCampaign_update = roleModuleUser[i]['update_permission'];
          this.menuCampaign_delete = roleModuleUser[i]['delete_permission'];

        }else if (roleModuleUser[i]['module_name'] == 'LeadsPeek') {
          //console.log(this.roleModuleUser[i]['module_name'] + ' | ' + this.roleModuleUser[i]['enable_permission']);
          this.menuLeadsPeek = roleModuleUser[i]['enable_permission'];
          this.menuLeadsPeek_create = roleModuleUser[i]['create_permission'];
          this.menuLeadsPeek_update = roleModuleUser[i]['update_permission'];
          this.menuLeadsPeek_delete = roleModuleUser[i]['delete_permission'];

        }else if (roleModuleUser[i]['module_name'] == 'Settings') {
          this.settingMenuShow = roleModuleUser[i]['enable_permission'];
          this.settingMenuShow_create = roleModuleUser[i]['create_permission'];
          this.settingMenuShow_update = roleModuleUser[i]['update_permission'];
          this.settingMenuShow_delete = roleModuleUser[i]['delete_permission'];
        }
    }  
  },

  initStripeScriptLoad(status) {
    this.stripescriptload = status;
  },

  /** GENERAL FUNCTION */
  formatNumber(n) {
    // format number 1000000 to 1,234,567
    return n.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
  },
  
  formatMoney(amount) {
    return amount.toLocaleString('en-US', {
      style: 'currency',
      currency: 'USD',
    });
  },

  formatCurrency(input,val, blur) {
    if (typeof val !== "number") {
      return val;
    }
    const formatter = new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      minimumFractionDigits: 0
    });
    return formatter.format(val);
    
    // appends $ to value, validates decimal side
    // and puts cursor back in right position.
    
    var input_val = '';
    // get input value
    if (typeof(val) != 'undefined' && val != '') {
        input_val = val;
    }else{
         input_val = input.val();
    }
    input_val = String(input_val);

    //console.log("INPUT : " + input_val + ' | ' + input_val.indexOf("."));
    // don't validate empty input
    if (input_val === "") { return; }
    
    // original length
    var original_len = input_val.length;
  
    // initial caret position 
    var caret_pos = '';
    if (typeof(val) != 'undefined' && val != '') {
        caret_pos = '';
    }else{
        caret_pos = input.prop("selectionStart");
    }
      
    // check for decimal
    if (input_val.indexOf(".") >= 0) {
  
      // get position of first decimal
      // this prevents multiple decimals from
      // being entered
      var decimal_pos = input_val.indexOf(".");
  
      // split number by decimal point
      var left_side = input_val.substring(0, decimal_pos);
      var right_side = input_val.substring(decimal_pos);
  
      // add commas to left side of number
      left_side = this.formatNumber(left_side);
  
      // validate right side
      right_side = this.formatNumber(right_side);
      
      // On blur make sure 2 numbers after decimal
      if (blur === "blur") {
        right_side += "00";
      }
      
      // Limit decimal to only 2 digits
      right_side = right_side.substring(0, 2);
  
      // join number by .
      //input_val = "$" + left_side + "." + right_side;
      input_val = left_side + "." + right_side;

    } else {
      // no decimal entered
      // add commas to number
      // remove all non-digits
      input_val = this.formatNumber(input_val);
      //input_val = "$" + input_val;
      input_val = input_val;

      // final formatting
      if (blur === "blur") {
        input_val += ".00";
      }
    }
    
    // send updated string to input
    if (typeof(val) != 'undefined' && val != '') {
        return input_val;
    }else{
        input.val(input_val);
    
        // put caret back in the right position
        var updated_len = input_val.length;
        caret_pos = updated_len - original_len + caret_pos;
        input[0].setSelectionRange(caret_pos, caret_pos);
    }
  },
  SetlocalStorage(storname,storval) {
    const envryptedObjectOri = CryptoJS.AES.encrypt(JSON.stringify(storval),process.env.VUE_APP_SECRET_KEY_CRYPTOJS);
    localStorage.setItem(storname, envryptedObjectOri);
  },
  getlocalStorage(storname) {
    const denvryptedObjectOri = localStorage.getItem(storname);
    return JSON.parse(CryptoJS.AES.decrypt(denvryptedObjectOri, process.env.VUE_APP_SECRET_KEY_CRYPTOJS ).toString(CryptoJS.enc.Utf8));
  },
  
  /** INTEGRATION SNAPSHOT MANAGEMENT */
  deepClone(obj) {
    if (obj === null || typeof obj !== 'object') return obj;
    if (obj instanceof Date) return new Date(obj.getTime());
    if (obj instanceof Array) return obj.map(item => this.deepClone(item));
    
    const clonedObj = {};
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        clonedObj[key] = this.deepClone(obj[key]);
      }
    }
    return clonedObj;
  },
  
  deepEqual(obj1, obj2) {
    if (obj1 === obj2) return true;
    if (obj1 == null || obj2 == null) return obj1 === obj2;
    if (typeof obj1 !== 'object' || typeof obj2 !== 'object') return obj1 === obj2;
    
    // Handle arrays
    if (Array.isArray(obj1) && Array.isArray(obj2)) {
      if (obj1.length !== obj2.length) return false;
      for (let i = 0; i < obj1.length; i++) {
        if (!this.deepEqual(obj1[i], obj2[i])) return false;
      }
      return true;
    }
    
    if (Array.isArray(obj1) !== Array.isArray(obj2)) return false;
    
    const keys1 = Object.keys(obj1);
    const keys2 = Object.keys(obj2);
    
    if (keys1.length !== keys2.length) return false;
    
    for (const key of keys1) {
      if (!keys2.includes(key)) return false;
      if (!this.deepEqual(obj1[key], obj2[key])) return false;
    }
    
    return true;
  },
  
  setIntegrationSnapshot(data) {
    this.integrationSnapshot = this.deepClone(data);
    this.isIntegrationClicked = false;
  },
  
  clearIntegrationSnapshot() {
    this.integrationSnapshot = null;
    this.isIntegrationClicked = false;
  },
  
  hasIntegrationChanges(currentData) {
    if (!this.integrationSnapshot) return false;
    return !this.deepEqual(this.integrationSnapshot, currentData);
  },

  validateGeneralPassword(dataObj) {
    for (let key in dataObj) {
      if (key.toLowerCase().includes('pass')) { 
        if (dataObj[key] && dataObj[key].length < 8) {
          return false;
        }
      }
    }
    return true;
  },
  async globalCheckSaveIntegration() {
    // Return 'stay' immediately if no changes detected
    if (!this.isIntegrationClicked) {
      return 'stay';
    }
    
    // Use custom HTML buttons with Promise-based approach
    return new Promise((resolve) => {
      let resolved = false;
      
      // Use event delegation on document to catch clicks
      const handleButtonClick = (e) => {
        if (resolved) return;
        
        const target = e.target;
        const targetId = target.id;
        
        if (targetId === 'swal-save-btn') {
          resolved = true;
          document.removeEventListener('click', handleButtonClick);
          swal.close();
          resolve('save');
        } else if (targetId === 'swal-discard-btn') {
          resolved = true;
          document.removeEventListener('click', handleButtonClick);
          swal.close();
          resolve('discard');
        } else if (targetId === 'swal-cancel-btn') {
          resolved = true;
          document.removeEventListener('click', handleButtonClick);
          swal.close();
          resolve('stay');
        }
      };
      
      // Attach event listener to document (event delegation)
      document.addEventListener('click', handleButtonClick);
      
      // Show the modal
      swal.fire({
        title: "You have unsaved changes",
        html: `
          <div style="margin-bottom: 32px; color: #606266; font-size: 15px; line-height: 1.5;">What would you like to do?</div>
          <div style="display: flex; flex-direction: column; gap: 12px; margin-top: 24px; max-width: 400px; margin-left: auto; margin-right: auto;">
            <button id="swal-save-btn" style="
              width: 100%;
              padding: 12px 24px;
              background: green;
              color: white;
              border: none;
              border-radius: 8px;
              font-size: 15px;
              font-weight: 600;
              cursor: pointer;
              transition: all 0.3s ease;
              box-shadow: 0 2px 8px rgba(103, 194, 58, 0.3);
            ">
              Save changes & switch
            </button>
            <button id="swal-discard-btn" style="
              width: 100%;
              padding: 12px 24px;
              background: #942434;
              color: white;
              border: none;
              border-radius: 8px;
              font-size: 15px;
              font-weight: 600;
              cursor: pointer;
              transition: all 0.3s ease;
              box-shadow: 0 2px 8px rgba(245, 108, 108, 0.3);
            ">
              Discard changes & switch
            </button>
            <button id="swal-cancel-btn" style="
              width: 100%;
              padding: 12px 24px;
              background: #fff;
              color: #606266;
              border: 2px solid #DCDFE6;
              border-radius: 8px;
              font-size: 15px;
              font-weight: 600;
              cursor: pointer;
              transition: all 0.3s ease;
            ">
              Stay here
            </button>
          </div>
          <style>
            #swal-save-btn:hover {
              transform: translateY(-1px);
            }
            #swal-discard-btn:hover {
              transform: translateY(-1px);
            }
            #swal-cancel-btn:hover {
              transform: translateY(-1px);
            }
            #swal-save-btn:active,
            #swal-discard-btn:active,
            #swal-cancel-btn:active {
              transform: translateY(0);
            }
          </style>
        `,
        showConfirmButton: false,
        showCancelButton: false,
        allowOutsideClick: false,
        allowEscapeKey: true,
        customClass: {
          popup: 'swal2-popup-modern'
        }
      }).then((result) => {
        // Clean up event listener if modal is closed by other means (e.g., escape key)
        document.removeEventListener('click', handleButtonClick);
        if (!resolved && result.dismiss === swal.DismissReason.esc) {
          resolved = true;
          resolve('stay');
        }
      });
    });
  },
  /** MODAL CAMPAIGN MANAGEMENT */
  confirmPauseCampaign() {
    return swal.fire({
      title: 'Are you sure you want to Pause this campaign?',
      html: `
        <div style="margin-top: 15px; line-height: 1.6; font-size: 17px; color: #666;">
          <div style="display: flex; text-align: left; margin-bottom: 12px;">
            <span style="margin-right: 10px;">•</span>
            <span>Paused campaigns will continue to charge any monthly campaign fees.</span>
          </div>
          <div style="display: flex; text-align: left; margin-bottom: 12px;">
            <span style="margin-right: 10px;">•</span>
            <span>Paused campaigns will not deliver any contacts.</span>
          </div>
          <div style="display: flex; text-align: left;">
            <span style="margin-right: 10px;">•</span>
            <span>Resuming a Paused campaign will not charge any startup fees for the campaign or contacts.</span>
          </div>
        </div>
        <div style="text-align: center; margin-top: 25px; font-weight: bold; font-size: 17px; color: #333;">
          You do not need to pause a campaign to edit it.
        </div>
      `,
      showCancelButton: true,
      confirmButtonText: 'Yes, Pause it!',
      cancelButtonText: 'Cancel',
      customClass: {
        confirmButton: 'btn btn-default btn-fill',
        cancelButton: 'btn btn-danger btn-fill'
      },
      buttonsStyling: false
    });
  },

  confirmStopCampaign() {
    return swal.fire({
      title: 'Are you sure you want to stop this campaign?',
      html: `
        <div style="margin-top: 15px; line-height: 1.6; font-size: 17px; color: #666;">
          <div style="display: flex; text-align: left; margin-bottom: 12px;">
            <span style="margin-right: 10px;">•</span>
            <span>Stopped campaigns will not charge any monthly campaign fees.</span>
          </div>
          <div style="display: flex; text-align: left; margin-bottom: 12px;">
            <span style="margin-right: 10px;">•</span>
            <span>Stopped campaigns will not deliver any contacts.</span>
          </div>
          <div style="display: flex; text-align: left;">
            <span style="margin-right: 10px;">•</span>
            <span>Resuming a Stopped campaign <b>will charge</b> any applicable startup fees for the campaign and also for contacts.</span>
          </div>
        </div>
        <div style="text-align: center; margin-top: 25px; font-weight: bold; font-size: 17px; color: #333;">
          You do not need to stop a campaign to edit it.
        </div>
      `,
      showCancelButton: true,
      confirmButtonText: 'Ok',
      cancelButtonText: 'Cancel',
      customClass: {
        confirmButton: 'btn btn-default btn-fill',
        cancelButton: 'btn btn-danger btn-fill'
      },
      buttonsStyling: false
    });
  },
  /** GENERAL FUNCTION */
};

const Global = {
    install(Vue, options) {
      let app = new Vue({
        data: {
          globalStore: GlobalStore
        }
      });
      Vue.prototype.$global = app.globalStore;
    }
  };
  
  export default Global;